import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProductCarousel from './Componants/ProductCarousel';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

export default function SingleProduct() {
    const [product, setData] = useState(null);
    const [imageArr, setImageArr] = useState(null);
    const { id } = useParams();
    
    const [BookFromData, setBookFromData] = useState({
        action: 'ProductEnquery',
        product_name: id,
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: ''
    });

    const [BookFromErrors, setBookFromErrors] = useState({
        inputFullName: '',
        inputNumber: '',
        inputEmail: '',
        inputCity: '',
        inputMessage: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);

    // Function to fetch data from the API
    const fetchData = async (id) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, {
                "action": "ProductDetails",
                "product": id
            });
            console.log(response.data.data);
            setData(response.data.data);
            const hisat = response.data.data;
            setImageArr([
                hisat.image_path_1 && {
                    url: hisat.image_path_1,
                },
                hisat.image_path_2 && {
                    url: hisat.image_path_2,
                },
                hisat.image_path_3 && {
                    url: hisat.image_path_3,
                },
                hisat.image_path_4 && {
                    url: hisat.image_path_4,
                },
                hisat.image_path_5 && {
                    url: hisat.image_path_5,
                },
            ].filter(Boolean))
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const OpenTingleModal = (modeltype) => {
        if (modeltype) {
            setModalVisible(true);
            setModalType(modeltype);
        } else {
            setModalVisible(false);
        }
    }

    useEffect(() => {
        fetchData(id);
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBookFromData(prevState => ({
            ...prevState,
            [name]: value
        }));

        // Clear error when user starts typing
        if (BookFromErrors[name]) {
            setBookFromErrors(prevState => ({
                ...prevState,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        if (!BookFromData.inputFullName.trim()) {
            errors.inputFullName = 'Full Name is required';
            isValid = false;
        }

        if (!BookFromData.inputNumber.trim()) {
            errors.inputNumber = 'Contact Number is required';
            isValid = false;
        } else if (!/^\d{10}$/.test(BookFromData.inputNumber.replace(/\D/g, ''))) {
            errors.inputNumber = 'Please enter a valid 10-digit phone number';
            isValid = false;
        }

        if (!BookFromData.inputEmail.trim()) {
            errors.inputEmail = 'Email Address is required';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BookFromData.inputEmail)) {
            errors.inputEmail = 'Please enter a valid email address';
            isValid = false;
        }

        if (!BookFromData.inputCity.trim()) {
            errors.inputCity = 'City is required';
            isValid = false;
        }
        if (!BookFromData.inputMessage.trim()) {
            errors.inputMessage = 'Message is required';
            isValid = false;
        }

        setBookFromErrors(errors);
        return isValid;
    };

    const toastId = useRef(null);
    const BookhandleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            // toast.error('Please fill all required fields correctly');
            return false;
        }

        setIsSubmitting(true);
        toastId.current = toast.loading("Please Wait...");
        
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL_MAIN}`, BookFromData);

            if (response.data.status === true) {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "success",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
                setModalVisible(false);
                setBookFromData({
                    action: 'ProductEnquery',
                    product_name: id,
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: ''
                });
                setBookFromErrors({
                    inputFullName: '',
                    inputNumber: '',
                    inputEmail: '',
                    inputCity: '',
                    inputMessage: ''
                });
            } else {
                toast.update(toastId.current, {
                    render: response.data.message,
                    type: "error",
                    autoClose: 5000,
                    closeOnClick: true,
                    isLoading: false
                });
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.update(toastId.current, {
                render: 'An error occurred. Please try again.',
                type: "error",
                autoClose: 5000,
                closeOnClick: true,
                isLoading: false
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer />           
            <section className="section section--masthead basic">
                <div className="container">
                    <div className="breadcrumbs">
                        <ol itemScope="" itemType="https://schema.org/BreadcrumbList">
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <Link itemProp="item" href="/">
                                    <span itemProp="name">Home</span>
                                </Link>
                                <meta itemProp="position" content="1" />
                            </li>
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <Link itemProp="item" to={product && product.Categorslug ? `/products/category/${product.Categorslug}` : ''}>
                                    <span itemProp="name">{product && product.CategoryName}</span>
                                </Link>
                                <meta itemProp="position" content="1" />
                            </li>
                            <li className="crumb" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <Link itemProp="item" to={product && product.Brandslug ? `/brand/${product.Brandslug}` : ''}>
                                    <span itemProp="name">{product && product.BrandName}</span>
                                </Link>
                                <meta itemProp="position" content="1" />
                            </li>
                            <li className="crumb crumb-3" itemProp="itemListElement" itemScope="" itemType="https://schema.org/ListItem">
                                <span itemProp="item">
                                    <span itemProp="name"><strong>{product && product.product_name}</strong></span>
                                </span>
                                <meta itemProp="position" content="2" />
                            </li>
                        </ol>
                    </div>
                </div>
            </section>
            <br /><br /><br />

            {/* <!-- Section – Product --> */}
            <section className="section section--product  mb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 col-lg-5 order-md-last">
                            {product &&
                                <div className="column column--right">
                                    <div className="logo">
                                        <a href="#">
                                            <img width="339" height="200" src={`${process.env.REACT_APP_API_URL}assets/images/tags/${product.BrandLogo}`} className="attachment-full size-full"
                                             alt={product.product_name} decoding="async" loading="lazy" style={{ width: 'auto', height: '40px' }} />
                                        </a></div>
                                    <h1>{product.product_name}</h1>
                                    <p><strong>MODEL:</strong>{product.model}</p>
                                    <h2>DESCRIPTION</h2>
                                    <div dangerouslySetInnerHTML={{ __html: product.description }} />
                                    <div className="actions">
                                        <div className="row g-3">
                                        {product.product_link &&
                                            <div className="col-12">
                                                <a href={`${product.product_link}`} target="_blank" className="btn">
                                                    <span>Enquire about this product</span>
                                                    <span className="icon">
                                                        <i className="fa fa-chevron-right"></i>
                                                    </span>
                                                </a>
                                            </div>
                                            }
                                            {product.brochure_link &&
                                                <div className="col-12">
                                                    <a target="_blank" className="btn btn--secondary" download href={`${process.env.REACT_APP_API_URL}assets/images/brochure/${product.brochure_link}`}>
                                                        <span>Download Brochure</span>
                                                        <span className="icon">
                                                            <i className="fa fa-chevron-right"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                            }
                                            <div className="col-12">
                                                <a onClick={() => OpenTingleModal('productenqurie')} className="btn" id="product-enquire" data-product="<?= $productrew['product_name']; ?>">
                                                    <span>Contact Us</span>
                                                    <span className="icon"><i className="fa fa-chevron-right"></i></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-md-5 col-lg-7 order-md-first">
                            <div className="column column--left">
                                {product && <ProductCarousel product={product.id} productImg={imageArr} />}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {product && product.more_info &&
                <section className="section section--product" style={{ background: 'var(--color-tertiary)' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-lg-12 pro-specs py-5">
                                <h2>PRODUCT DETAILS</h2>
                                <div dangerouslySetInnerHTML={{ __html: product.more_info }} />   </div>
                        </div>
                    </div>
                </section>
            }

            <div className={`tingle-modal tingle-modal--overflow ${modalVisible ? 'tingle-modal--visible' : ''}`} id="tingle-modal23">
                <button type="button" className="tingle-modal__close" id="tingle-modal__close23" onClick={() => OpenTingleModal()}>
                    <span className="tingle-modal__closeIcon">
                    </span>
                    <span className="tingle-modal__closeLabel">Close</span>
                </button>
                <div className="tingle-modal-box">
                    <div className="tingle-modal-box__content">
                        {modalType && modalType === 'productenqurie' &&
                            <div id="demonstration1" className="modal-content">
                                <div className="wysiwyg">
                                    <h2>
                                        <strong>Enquire About Product</strong>
                                    </h2>
                                </div>
                                <div className="wpcf7 js" id="wpcf7-f698-o1" lang="en-GB" dir="ltr">
                                    <div className="screen-reader-response">
                                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                                        <ul></ul>
                                    </div>
                                    <form onSubmit={BookhandleSubmit} method="post" id="add_Form" className="wpcf7-form init">
                                        {/* Full Name */}
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input 
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required ${BookFromErrors.inputFullName ? 'error' : ''}`}
                                                    name="inputFullName"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputFullName}
                                                    type="text"
                                                    id="inputFullName"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputFullName">Full Name*</label>
                                                {BookFromErrors.inputFullName && <span className="error-message">{BookFromErrors.inputFullName}</span>}
                                            </p>
                                        </div>

                                        {/* Contact Number */}
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input 
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel ${BookFromErrors.inputNumber ? 'error' : ''}`}
                                                    name="inputNumber"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputNumber}
                                                    type="tel"
                                                    id="inputNumber"
                                                    placeholder=" "
                                                    maxLength={10}
                                                />
                                                <label className="label" htmlFor="inputNumber">Contact Number*</label>
                                                {BookFromErrors.inputNumber && <span className="error-message">{BookFromErrors.inputNumber}</span>}
                                            </p>
                                        </div>

                                        {/* Email Address */}
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input 
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email ${BookFromErrors.inputEmail ? 'error' : ''}`}
                                                    name="inputEmail"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputEmail}
                                                    type="email"
                                                    id="inputEmail"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputEmail">Email Address*</label>
                                                {BookFromErrors.inputEmail && <span className="error-message">{BookFromErrors.inputEmail}</span>}
                                            </p>
                                        </div>

                                        {/* City - New Field Added */}
                                        <div className="form-group form-label-field">
                                            <p>
                                                <input 
                                                    size="40"
                                                    onChange={handleChange}
                                                    className={`wpcf7-form-control wpcf7-text ${BookFromErrors.inputCity ? 'error' : ''}`}
                                                    name="inputCity"
                                                    aria-required="true"
                                                    aria-invalid="false"
                                                    value={BookFromData.inputCity}
                                                    type="text"
                                                    id="inputCity"
                                                    placeholder=" "
                                                />
                                                <label className="label" htmlFor="inputCity">City*</label>
                                                {BookFromErrors.inputCity && <span className="error-message">{BookFromErrors.inputCity}</span>}
                                            </p>
                                        </div>

                                        {/* How can we help */}
                                        <div className="form-group form-label-field">
                                            <p>
                                                <textarea
                                                    onChange={handleChange}
                                                    cols="40" 
                                                    rows="10"
                                                    className={`wpcf7-form-control wpcf7-textarea ${BookFromErrors.inputMessage ? 'error' : ''}`}
                                                    name="inputMessage"
                                                    aria-invalid="false"
                                                    id="inputMessage"
                                                    value={BookFromData.inputMessage}
                                                    placeholder=" "
                                                ></textarea>
                                                <label className="label" htmlFor="inputMessage">How can we help?</label>
                                                {BookFromErrors.inputMessage && <span className="error-message">{BookFromErrors.inputMessage}</span>}
                                            </p>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col">
                                                <p>*Required</p>
                                            </div>
                                            <div className="col-5">
                                                <p>
                                                    <button 
                                                        className="btn btn--secondary btn--block"
                                                        name="DemonstrationSubmit" 
                                                        id="DemonstrationSubmit" 
                                                        type="submit"
                                                        disabled={isSubmitting}
                                                    >
                                                        <span>{isSubmitting ? 'Sending...' : 'Send'}</span>
                                                        <span className="icon"></span>
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="wpcf7-response-output" aria-hidden="true"></div>
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
